import ReactDropdown from 'react-dropdown';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  gap: 20px 0;
`;

export const FormGroup = styled.div`
  margin-bottom: 12px;
`;

export const ChipButtonsWrapper = styled.div`
  width: 100%;
  position: relative;
  /* left: -20px; */
  margin-bottom: 12px;

  ${({ theme }) => theme.media.mobile} {
    width: 100vw;
    left: -20px;

    & > div {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
`;

export const Label = styled.label`
  display: inline-block;
  margin-bottom: 12px;
  ${({ theme }) => theme.typography('$body_02')};
  color: ${({ theme }) => theme.palette.grayscale500};
`;

export const Input = styled.input`
  width: 100%;
  height: 52px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.bg500};
  background-color: ${({ theme }) => theme.palette.bg900};
  color: #fff;
  ${({ theme }) => theme.typography('$body_03')};

  &::placeholder {
    color: ${({ theme }) => theme.palette.grayscale700};
  }
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px 0;
`;

export const StyledLine = styled.div`
  width: 100%;
  text-align: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.bg800};
`;
export const CountBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  button {
    height: 100%;
    padding: 1rem;
  }
`;

export const DropdownBox = styled.div`
  div {
    background-color: #373245;
    color: #ccc;
    border: none;
    border-radius: 0.8rem;
  }

  // react library의 내부 클래스를 다룸 기본값 padding-right: 52px
  .Dropdown-control {
    padding-right: 26px;
  }
`;

export const ButtonBox = styled.div`
  height: 100%;
  display: flex;
  gap: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    height: 100%;
  }
`;

export const EndTime = styled.div`
  padding: 10px;
  display: flex;
  gap: 10px;

  div > .arrow {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #999;
    position: relative;
    top: 3px;
  }
`;

export const Dropdown = styled(ReactDropdown)`
  width: 100px;
`;
